import cookies from 'js-cookie';
import {classList, dataset, lazyCustomElements, listen} from 'nuffjs';

let embedExternalVideos = null;
// let isPaused = null;
// const autoplayCookieName = 'autoplayAnimations';
// const autoplay = cookies.get(autoplayCookieName);
// if (autoplay === '1') {
// 	isPaused = false;
// } else if (autoplay === '0') {
// 	isPaused = true;
// } else {
// 	const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
// 	isPaused = !mediaQuery || mediaQuery.matches;
// }
// cookies.set(autoplayCookieName, isPaused ? '0' : '1');

/**
 * @classdesc Element Wrapping a {@link VideoPlayer} in order to provide a temporary cover. It is
 * usually a cover image inside a link (for external players, the link points to the external video
 * URL in order to support the CTRL+click intention by users). When clicked the cover element
 * disappears and let the video player take full control. It should also support a cookie consent
 * integration and respect for the prefers-reduced-motion preference, but it is not ready yet for
 * those tasks. Needs to be finished.
 *
 * @class VideoPlayerCover
 * @extends {HTMLElement}
 * @version 0.1.0
 * @path
 *
 */
class VideoPlayerCover extends HTMLElement {
	static defaultOpts = {
		playerAttr: 'videoPlayer',
		linkAttribute: 'videoLink',
		loadingClass: 'loading',
		loadedClass: 'loaded',
		embedExternalVideosClass: 'embedExternalVideos',
		embedExternalVideosCookieName: '',
	};

	async firstConnectedCallback() {
		this.opts = dataset(this).get(this.constructor.defaultOpts);
		if (embedExternalVideos === null) {
			embedExternalVideos = +!!cookies.get(this.opts.embedExternalVideosCookieName);
		}
		this.opened = false;
		this.link = this.querySelector(dataset.selector(this.opts.linkAttribute));
		this.player = await lazyCustomElements.querySelector(
			this,
			dataset.selector(this.opts.playerAttr)
		);
		if (this.link && this.player) {
			listen(this, 'click', this.onClick.bind(this), {
				selector: dataset.selector(this.opts.linkAttribute),
			});
		} else {
			this.opened = true;
		}
		// currently not implemented
		this.privacyToggler = null; //this.getComponent('TogglerField');
		if (this.privacyToggler) {
			this.listeners.togglerChange = listen(
				document,
				'field:change',
				this.onPrivacyTogglerChange.bind(this)
			);
		}
	}

	onClick(event) {
		if (event.button === 0 && !event.ctrlKey && !event.metaKey) {
			event.preventDefault();
			const cl = classList(this);
			cl.add(this.opts.loadingClass);
			this.player.load().then(() => {
				cl.add(this.loadedClass);
				cl.remove(this.loadingClass);
			});
			this.opened = true;
		}
	}

	onPrivacyTogglerChange(event) {
		const component = event.detail.component;
		const owned = this.element.contains(component.getElement());
		const value = component.getValue();
		console.log('toggle', value, owned);
		if (owned) {
			embedExternalVideos = value;
			cookies.set(this.embedExternalVideosCookieName, embedExternalVideos);
		} else if (this.privacyToggler) {
			this.privacyToggler.setValue(value);
		}
		this.updateExternalVideosStatus(value);
	}

	updateExternalVideosStatus(value) {
		if (value || !this.opened) {
			this.classList().toggle(this.embedExternalVideosClass, value);
		}
	}
}

export {VideoPlayerCover};
